import BetModel from "slotworks/model/bets/bet-model";
import GameState from "slotworks/model/game-state";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";

export default class IsWinOverThreshold extends Decision {
    public evaluate() {
        const win = GameState.getCurrentGame().getCurrentRecord().cashWon / BetModel.getTotalStake();

        const threshold = 0;

        return win > threshold ? Exit.True : Exit.False;
    }
}
